export const VOTETHUMB__32 = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<g fill="none" fill-rule="evenodd">
    <path d="M-1243-708h4069v2389h-4069z"/>
    <g>
        <rect width="30.5" height="30.5" x=".75" y=".75" rx="15.25"/>
        <g class="vote-thumb-svg">
            <path stroke-linecap="round" d="M13.773 22H9a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h1"/>
            <path stroke-linecap="square" d="M13 15l1.998-7c1.132 0 1.997.827 1.997 1.91v3.817h4.995a1.996 1.996 0 0 1 1.997 2.228l-.732 4.454c-.133.955-.999 1.591-1.998 1.591H13v-7z"/>
        </g>
        <path d="M4 3h24v24H4z"/>
    </g>
</g>
</svg>
`;

export const VOTEPLUS__32 = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<g fill="none" fill-rule="evenodd">
    <g>
        <text class="vote-plus-svg" font-family="Lato-Bold, Lato" font-size="14" font-weight="bold">
            <tspan x="7" y="21">+1</tspan>
        </text>
    </g>
</g>
</svg>
`;

export const VOTEDPLUS__32 = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<g fill="none" fill-rule="evenodd">
    <g>
        <g fill-rule="nonzero">
            <path d="M4 4h24v24H4z"/>
            <path class="voted-plus-svg" d="M13 20.17l-3.465-3.465a1 1 0 0 0-1.412-.003l-.003.003a.997.997 0 0 0-.002 1.413l4.175 4.175a1 1 0 0 0 1.414 0l10.588-10.588a.997.997 0 0 0-1.41-1.41L13 20.17z"/>
        </g>
    </g>
</g>
</svg>
`;

export const VOTETHUMB__16 = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
<g fill="none" fill-rule="evenodd">
    <path d="M0-1h16v16H0z"/>
    <g stroke="#323F4D" stroke-linecap="square" stroke-width="1.5">
        <path d="M4.5 13.25H1.75A.75.75 0 0 1 1 12.5V7.875a.75.75 0 0 1 .75-.75h1M5.375 7.125L7.123 1c.99 0 1.748.724 1.748 1.67v3.341h4.37c1.049 0 1.864.891 1.748 1.95l-.641 3.897c-.117.835-.874 1.392-1.748 1.392H5.375V7.125z"/>
    </g>
</g>
</svg>
`;

export const VOTEDTHUMB__16 = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
<g fill="none" fill-rule="evenodd">
    <path d="M0-1h16v16H0z"/>
    <g stroke="#323F4D" stroke-linecap="square" stroke-width="1.5" fill-rule="nonzero" fill="#0067db">
        <path d="M4.5 13.25H1.75A.75.75 0 0 1 1 12.5V7.875a.75.75 0 0 1 .75-.75h1M5.375 7.125L7.123 1c.99 0 1.748.724 1.748 1.67v3.341h4.37c1.049 0 1.864.891 1.748 1.95l-.641 3.897c-.117.835-.874 1.392-1.748 1.392H5.375V7.125z"/>
    </g>
</g>
</svg>
`;

export const VOTEPLUS__16 = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
<g fill="none" fill-rule="evenodd">
    <g>
        <text class="vote-plus-svg" font-family="Lato-Bold, Lato" font-size="14" font-weight="bold">
            <tspan x="7" y="21">+1</tspan>
        </text>
    </g>
</g>
</svg>
`;

export const VOTEDPLUS__16 = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
<g fill="none" fill-rule="evenodd">
    <g>
        <g fill-rule="nonzero">
            <path d="M4 4h24v24H4z"/>
            <path class="voted-plus-svg" d="M13 20.17l-3.465-3.465a1 1 0 0 0-1.412-.003l-.003.003a.997.997 0 0 0-.002 1.413l4.175 4.175a1 1 0 0 0 1.414 0l10.588-10.588a.997.997 0 0 0-1.41-1.41L13 20.17z"/>
        </g>
    </g>
</g>
</svg>
`;



// WEBPACK FOOTER //
// ./src/universal/components/svg-def/votes.js